module.exports = __webpack_public_path__ + "static/media/1-1.66e26ba2.png";